import { render, staticRenderFns } from "./SendMeal1Report.vue?vue&type=template&id=1ecb378d&scoped=true&"
import script from "./SendMeal1Report.vue?vue&type=script&lang=js&"
export * from "./SendMeal1Report.vue?vue&type=script&lang=js&"
import style0 from "./SendMeal1Report.vue?vue&type=style&index=0&id=1ecb378d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecb378d",
  null
  
)

export default component.exports